/**
 * Fleet Module
 *
 * This module provides fleet management functionality including:
 * - Vehicle management (Vozila)
 * - Service tracking (Servisi)
 * - Contract management (Ugovori)
 * - Tire procurement (Nabavka guma)
 * - Travel orders (Putni nalozi)
 * - Reports (Izvještaji)
 * - Registration management (Registracije)
 */

import type { ModuleDefinition } from '@core/router/types';
import { fleetRoutes } from './routes';
import { fleetNavigation, fleetModuleInfo } from './navigation';

/**
 * Fleet Module Definition
 *
 * Registers the fleet module with the application.
 */
export const fleetsModule: ModuleDefinition = {
  name: 'vozni-park',
  basePath: '/vozni-park',
  routes: fleetRoutes,
  navigation: fleetNavigation,
  moduleInfo: fleetModuleInfo,
};

export default fleetsModule;
